export const chartMd = 600;
export const chartSm = 350;
export const chartXs = 250;

export const lineChartLeftMargin = 60;
export const lineChartTopMargin = 10;
export const lineChartBottomMargin = 30;
export const lineChartRightMargin = 20;
export const defaultMargin = 10;